import React from 'react';
import type { PageTitleProps, TutorialHeaderProps } from '@goodfynd/content';
import { PageTitle, TutorialHeader } from '@goodfynd/content';

import type { CmsComponentTitleTypes } from './types';

export default function renderCmsTitleComponent(
  index: number,
  componentType: CmsComponentTitleTypes,
  fields: Record<string, unknown>
) {
  switch (componentType) {
    case 'page_title':
      return (
        <PageTitle
          {...(fields as unknown as PageTitleProps)}
          key={componentType + index}
        />
      );

    case 'tutorial_header':
      return (
        <TutorialHeader
          {...(fields as unknown as TutorialHeaderProps)}
          key={componentType + index}
        />
      );

    default:
      return null;
  }
}
